export default __webpack_public_path__ + "static/media/ES Social Media Marketing Management.329ba440.jpg";